import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { persistStore, autoRehydrate } from 'redux-persist'
import { Provider, connect } from 'react-redux';
import thunk from 'redux-thunk';
import { createBrowserHistory } from "history";
import { Route, Switch } from 'react-router'
import { ConnectedRouter, routerReducer, routerMiddleware } from 'react-router-redux'
import { Redirect, BrowserRouter } from 'react-router-dom'
import { I18n } from 'react-polyglot';
import locales from './i18n';
import { profileTypes, mapProfileTypeToSlug, userAuthStages, mapUserGatewayProfileType, userProfileType, siteLocaleLanguages, siteLocale as oldLanguage, isOdosWeek} from './lib/constants';
import { setupLoggly } from './lib/loggly';
import { CookiesProvider } from 'react-cookie';
import Loadable from 'react-loadable';

//import initGoogleAnalytics from './lib/googleAnalytics';
import RTLProvider from './components/RTLProvider/RTLProvider';
// Reducers
import allFiltersReducer from './redux/allFiltersReducer'
import profileReducer from './redux/profileReducer';
import viewportReducer from './redux/viewportReducer';
import userReducer from './redux/userReducer';
import newsletterReducer from './redux/newsletterReducer';
import readingListsReducer from './redux/readingListsReducer';
import translateReducer from './redux/translateReducer';
import slimNotificationReducer from './redux/slimNotificationReducer';
import bookReducer from './redux/bookReducer';
import offlineBooksReducer from './redux/offlineBooksReducer';
import homeReducer from './redux/homeReducer';
import allBooksReducer from './redux/allBooksReducer';
import networkReducer from './redux/networkReducer';
import allListsReducer from './redux/allListsReducer';
import allIllustrationsReducer from './redux/allIllustrationsReducer';
import illustrationReducer from './redux/illustrationReducer';
import expandedSearchReducer from './redux/expandedSearchReducer';
import imagesSearchReducer from './redux/imagesSearchReducer';
import listsSearchReducer from './redux/readingListsSearchReducer';
import peopleSearchReducer from './redux/peopleSearchReducer';
import offlineBookModalReducer from './redux/offlineBookModalReducer';
import userFeedbackModalReducer from './redux/userFeedbackModalReducer';
import notificationModalReducer from './redux/notificationModalReducer';
import windowSizeReducer from './redux/windowSizeReducer';
import nextTranslationReducer from './redux/nextTranslationReducer';
import smileyRatingModalReducer from './redux/smileyRatingModalReducer';
import gatingFormReducer from './redux/gatingFormReducer';
import allFluencesReducer from './redux/allFluencesReducer';
import portraitViewMessageReducer from './redux/portraitViewMessageReducer';
import allMobileTranslateReducer from './redux/allMobileTranslateReducer';
import csfReducer from './redux/csfReducer';
import eceReducer from './redux/eceReducer';
import flpHomeReducer from './redux/flpHomeReducer';
import stemReducer from './redux/stemReducer';

import { openAuthModal, changeLanguage } from './redux/userActions';

import ErrorPage from './components/ErrorPage';

// Containers for the routes , no lazy loading on these as it effects offline
import OfflineBooksContainer from './components/OfflineBooksContainer';
import LessonPlanContainer from './components/LessonPlanContainer';

// Loader component
import LoaderBlock from './components/LoaderBlock';

// Main App component
import AppContainer from './components/AppContainer';

// Set up our redux store.
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const history = createBrowserHistory();

history.listen(location => window.scrollTo(0, 0))

const middleware = [thunk, routerMiddleware(history)];

// Load Google Analytics
// if (process.env.REACT_APP_GA_PROPERTY_ID) {
//   initGoogleAnalytics(process.env.REACT_APP_GA_PROPERTY_ID);
//   middleware.push(googleAnalyticsMiddleware);
// }

const store = createStore(
  combineReducers({
    router: routerReducer,
    viewport: viewportReducer,
    profile: profileReducer,
    user: userReducer,
    newsletter: newsletterReducer,
    readingLists: readingListsReducer,
    translate: translateReducer,
    slimNotification: slimNotificationReducer,
    book: bookReducer,
    offlineBooks: offlineBooksReducer,
    offlineBookModal: offlineBookModalReducer,
    home: homeReducer,
    allBooks: allBooksReducer,
    allFilters: allFiltersReducer,
    network: networkReducer,
    allLists: allListsReducer,
    expandedSearch: expandedSearchReducer,
    images: imagesSearchReducer,
    listsSearch: listsSearchReducer,
    people: peopleSearchReducer,
    nextTranslation: nextTranslationReducer,
    allImages: allIllustrationsReducer,
    illustration: illustrationReducer,
    userFeedbackModal: userFeedbackModalReducer,
    notificationModal: notificationModalReducer,
    windowDimensions: windowSizeReducer,
    smileyRatingModal: smileyRatingModalReducer,
    gatingForm: gatingFormReducer,
    allFluences: allFluencesReducer,
    portraitViewMessage: portraitViewMessageReducer,
    allMobileTranslate:  allMobileTranslateReducer,
    csf: csfReducer,
    ece: eceReducer,
    flpHome: flpHomeReducer,
    stem: stemReducer,
  }),
  composeEnhancers(
    applyMiddleware(...middleware),
    autoRehydrate()
  )
);

persistStore(store, {
  whitelist: ['offlineBooks', 'userFeedbackModal']
})
// initMessageListener(store);
// Set up Loggly for development mode.
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_LOGGLY_KEY) {
  setupLoggly(process.env.REACT_APP_LOGGLY_KEY);
}

const RouteWithOfflineRedirect = ({ component: Component, render, ...rest }) => (
  <Route
    {...rest}
    render={
      window.navigator.onLine
        ? render ? render : props => <Component {...props} />
        : prop => <Redirect to="/offline" />
    }
  />
)


const mapStateToProps = state => {
  return {
    user: state.user,
  }
}
@connect(mapStateToProps)


class ProfileHomeContainer extends Component {
  render() {
    const { user } = this.props;
    if(user.isLoggedIn) {
      let role = user.profile.profile_type ? mapUserGatewayProfileType[user.profile.profile_type.toLowerCase()] : null; 
      if (role && role !== "default") return <Redirect to={`/${role}`} />;
      else return <HomeContainer />
    }
    else return <HomeContainer />
  }
}
@connect(null, { openAuthModal })
class ResetPasswordRoute extends Component {
  componentDidMount() {
    const { match } = this.props
    this.props.openAuthModal({
      stage: userAuthStages.newPassword,
      resetPasswordToken: match.params.token
    })
  }
  render() {
    return <HomeContainer />
  }
}

// Containers for the routes lazy loaded

const BookContainer = Loadable({
	loader: () => import('./components/BookContainer'),
	loading() {
		return <LoaderBlock size={"xl"}/>
	}
})

const EmbedBookCard = Loadable({
	loader: () => import('./components/EmbedBookCard'),
	loading() {
		return <LoaderBlock/>
	}
})

const EmbedBookReaderContainer = Loadable({
	loader: () => import('./components/EmbedBookReaderContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const HomeContainer = Loadable({
	loader: () => import('./components/HomeContainer'),
	loading() {
		return <LoaderBlock size={"xl"}/>
	}
})

const ListsHomeContainer = Loadable({
	loader: () => import('./components/ListsHomeContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const AllListsContainer = Loadable({
	loader: () => import('./components/AllListsContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const SpCampaignsPage = Loadable({
	loader: () => import('./components/SpCampaignsPage/SpExplorePage'),
	loading() {
		return <LoaderBlock/>
	}
})

const SpCovid19Page = Loadable({
	loader: () => import('./components/SpCovid19Page/SpCovid19Page'),
	loading() {
		return <LoaderBlock/>
	}
})

const SpAllImpactsPage = Loadable({
	loader: () => import('./components/SpAllImpactsPage'),
	loading() {
		return <LoaderBlock/>
	}
})

const ProfileContainer = Loadable({
	loader: () => import('./components/ProfileContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const UserProfileContainer = Loadable({
	loader: () => import('./components/UserProfileContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const StemGroupings = Loadable({
  loader: ()=> import ('./components/StemIntroContainer/StemGroupings'),
  loading() {
    return <LoaderBlock/>
  }
})

const TranslatePartnerContainer = Loadable({
	loader: () => import('./components/TranslatePartnerContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const ReadingListContainer = Loadable({
	loader: () => import('./components/ReadingListContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const AllBooksContainer = Loadable({
  loader: () => import('./components/AllBooksContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const TranslateContainer = Loadable({
	loader: () => import('./components/TranslateContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const AllTranslateListingContainer = Loadable({
	loader: () => import('./components/AllTranslateListingContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const AllImagesContainer = Loadable({
	loader: () => import('./components/AllImagesContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const IllustrationContainer = Loadable({
	loader: () => import('./components/IllustrationContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const MyListsContainer = Loadable({
	loader: () => import('./components/MyListsContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const EmailConfirmationContainer = Loadable({
	loader: () => import('./components/EmailConfirmationContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const ThirdPartyUserAuthContainer = Loadable({
	loader: () => import('./components/ThirdPartyUserAuthContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

//mobile-translate

const MobileTranslateContainer = Loadable({
	loader: () => import('./components/MobileTranslateContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const MobileTranslatePublishContainer = Loadable({
	loader: () => import('./components/MobileTranslatePublishContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const EceLandingContainer = Loadable({
	loader: () => import('./components/EceLandingContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const EceThemeContainer = Loadable({
	loader: () => import('./components/EceThemeContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const EceVideosContainer = Loadable({
	loader: () => import('./components/EceVideosContainer'),
	loading() {
		return <LoaderBlock/>
	}
})

const EceConversationContainer = Loadable({
	loader: () => import('./components/EceConversationContainer'),
	loading() {
		return <LoaderBlock/>
	}
})
// reading program
const FluencyContainer = Loadable({
  loader: () => import('./components/FluencyContainer'),
  loading() {
    return <LoaderBlock />
  }
})

const ReadingProgramLandingContainer = Loadable({
  loader: () => import('./components/ReadingProgramLandingContainer'),
  loading() {
    return <LoaderBlock />
  }
})

const ThemeContainer = Loadable({
  loader: () => import('./components/ThemeContainer'),
  loading() {
    return <LoaderBlock />
  }
})

const Channel = Loadable({
  loader: () => import('./components/Channel'),
  loading() {
    return <LoaderBlock />
  }
})

//csf feature

const CsfLandingContainer = Loadable({
  loader: () => import('./components/CsfLandingContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const CsfProgramOverviewContainer = Loadable({
  loader: () => import('./components/CsfProgramOverviewContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const CsfLevelContainer = Loadable({
  loader: () => import('./components/CsfLevelContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const CsfResourceContainer = Loadable({
  loader: () => import('./components/CsfResourceContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const FlpClassroomLandingContainer = Loadable({
  loader: () => import('./components/FlpClassroomLandingContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const FlpReadAtHomeLandingContainer = Loadable({
  loader: () => import('./components/FlpReadAtHomeLandingContainer'),
  loading(){
    return <LoaderBlock />
  }
})


const FlpReadAtHomeAboutContainer = Loadable({
  loader: () => import('./components/FlpReadAtHomeAboutContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const FlpReadAtHomeResourceContainer = Loadable({
  loader: () => import('./components/FlpReadAtHomeResourceContainer'),
  loading(){
    return <LoaderBlock />
  }
})

// static pages

const Contacts = Loadable({
  loader: () => import('./components/Contacts/Contacts'),
  loading(){
    return <LoaderBlock />
  }
})

const SpFaqContainer = Loadable({
  loader: () => import('./components/SpFaqContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const SpAwardsContainer = Loadable({
  loader: () => import('./components/SpAwardsContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const SpCareerContainer = Loadable({
  loader: () => import('./components/SpCareerContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const SpCareerDetailPage = Loadable({
  loader: () => import('./components/SpCareerDetailPage'),
  loading(){
    return <LoaderBlock />
  }
})

const DonatePage = Loadable({
  loader: () => import('./components/DonatePage'),
  loading(){
    return <LoaderBlock />
  }
})

const JotformContainer = Loadable({
  loader: () => import('./components/JotformContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const SpContainer = Loadable({
  loader: () => import('./components/SpContainer'),
  loading(){
    return <LoaderBlock />
  }
})
const SpIndvCampaignPage = Loadable({
  loader: () => import('./components/SpIndvCampaignPage'),
  loading(){
    return <LoaderBlock />
  }
})
const SpExploreCampaignPage = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreCampaignPage'),
  loading(){
    return <LoaderBlock/>
  }
})

const StemHome = Loadable({
  loader: () => import('./components/StemHome'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSBforKids = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSBforKids'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSeo1 = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSeo1'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSeo2 = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSeo2'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSeo3 = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSeo3'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSeo4 = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSeo4'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSeo5 = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSeo5'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSeo6 = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSeo6'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSeo7 = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSeo7'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSeo8 = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSeo8'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSeo9 = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSeo9'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSeo10 = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSeo10'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSeo11 = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSeo11'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpExploreSeo12 = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpExploreSeo12'),
  loading(){
    return <LoaderBlock/>
  }
})

const SpCbseCampaignPage = Loadable({
  loader: () => import('./components/SpCbseCampaignPage'),
  loading(){
    return <LoaderBlock />
  }
})

const SpFlpCampaignPage = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpFlpCampaignPage'),
  loading(){
    return <LoaderBlock />
  }
})

const SpCbseCampaignPageFaqs = Loadable({
  loader: () => import('./components/SpCbseCampaignPageFaqs'),
  loading(){
    return <LoaderBlock />
  }
})
const SpFreeOnlineBooksExplorePage = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpFreeOnlineBooksExplorePage'),
  loading(){
    return <LoaderBlock />
  }
})
const SpStoryBookEnglishExplorePage = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpStoryBookEnglishExplorePage'),
  loading(){
    return <LoaderBlock />
  }
})
const SpReadingChildrenImpExplorePage = Loadable({
  loader: () => import('./components/SpCbseCampaignPage/SpReadingChildrenImpExplorePage'),
  loading(){
    return <LoaderBlock />
  }
})
const SpCbseBuddingAuthors = Loadable({
  loader: () => import('./components/SpCbseBuddingAuthors/SpCbseBuddingAuthors'),
  loading(){
    return <LoaderBlock />
  }
})

const SpPledgeToRead = Loadable({
  //TODO change the flag isOdosWeek when required
  loader: () => isOdosWeek ? import('./components/SpPledgeToRead/SpPledgeToOdos') : import('./components/SpPledgeToRead/SpPledgeToRead'),
  loading(){
    return <LoaderBlock />
  }
})

const SpPledgeToReadPartner = Loadable({
  loader: () => import('./components/SpPledgeToRead/SpPledgeToReadPartner'),
  loading(){
    return <LoaderBlock />
  }
})

const SpOdosCertificate = Loadable({
  loader: () => import('./components/SpPledgeToRead/SpOdosCertificate'),
  loading(){
    return <LoaderBlock />
  }
})

const GcrSubCampaign = Loadable({
  loader: () => import('./components/SpPledgeToRead/GcrSubCampaign'),
  loading(){
    return <LoaderBlock />
  }
})

const PTRVideoPage = Loadable({
  loader: () => import('./components/PTRVideoPage/PTRVideoPage'),
  loading(){
    return <LoaderBlock />
  }
})

const SpStemCampaign = Loadable({
  loader: () => import('./components/SpStemCampaign/SpStemCampaign'),
  loading(){
    return <LoaderBlock />
  }
})

const SpStandardCampaign = Loadable({
  loader: () => import('./components/SpStandardCampaign/SpStandardCampaign'),
  loading(){
    return <LoaderBlock />
  }
})

const StemTopicContainer = Loadable({
  loader: () => import('./components/StemTopicContainer/StemTopicContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const StemTagContainer = Loadable({
  loader: () => import('./components/StemTagContainer/StemTagContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const StemMoocContainer = Loadable({
  loader: () => import('./components/StemMoocContainer/StemMoocContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const StemMoocModuleContainer = Loadable({
  loader: () => import('./components/StemMoocModuleContainer/StemMoocModuleContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const StemIntroContainer = Loadable({
  loader: () => import('./components/StemIntroContainer/StemIntroContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const FlpCreateClassroom = Loadable({
  loader: () => import('./components/FlpCreateClassroom/FlpCreateClassroom'),
  loading(){
    return <LoaderBlock />
  }
})

const FlpStudentClassroom = Loadable({
  loader: () => import('./components/FlpStudentClassroom/FlpStudentClassroom'),
  loading(){
    return <LoaderBlock />
  }
})

const SpMediaContainer = Loadable({
  loader: () => import('./components/SpMediaContainer/SpMediaContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const SpStandardNewsPage = Loadable({
  loader: () => import('./components/SpStandardNewsPage/SpStandardNewsPage'),
  loading(){
    return <LoaderBlock />
  }
})

const FlpAllBooksContainer = Loadable({
  loader: () => import('./components/FlpAllBooksContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const ImpactStaticPageContainer = Loadable({
  loader: () => import('./components/ImpactStaticPageContainer'),
  loading(){
    return <LoaderBlock />
  }
})

const ResourcesLandingPage = Loadable({
  loader: () => import('./components/ResourcesLandingPage/ResourcesLandingPage'),
  loading(){
    return <LoaderBlock />
  }
})

const EventTypeCertificate = Loadable({
  loader: () => import('./components/EventTypeCertificate'),
  loading(){
    return <LoaderBlock />
  }
})
// Set up locale

let ConnectedI18n = connect(mapStateToProps) (({ children, user }) => {
  let locale = localStorage.getItem('locale') || 'en';
  const messages = locales[locale]
  return (
    <I18n locale={locale} messages={messages}>
      {children}
    </I18n>
  )
})

// Set up forced locale
let ProgramSpecificI18n = ({ component: Component, render, ...rest }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const locale = urlParams.get('language') || 'en';
  let messages = Object.keys(locales).includes(locale) ? locales[locale] : locales['en']
  return (
    <I18n locale={locale} messages={messages}>
      <Route
        {...rest}
        render={
          window.navigator.onLine
            ? render ? render : props => <Component {...props} />
            : prop => <Redirect to="/offline" />
        }
      />
    </I18n>
  )
}

let ProgramSpecificWithoutRedirect = ({ component: Component, render, ...rest }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const locale = urlParams.get('language') || 'en';
  let messages = locales[locale]

  return (
    <I18n locale={locale} messages={messages}>
      <Route
        {...rest}
        render={
            render ? render : props => <Component {...props} />
        }
      />
    </I18n>
  )
}


// function userRedirect(nextState, replace) {
//   var defaultLanguage = 'en-gb';
//   localStorage.setItem()
// };

@connect(null, { changeLanguage})
class ExtendedBrowserRouter extends Component {  
  
  constructor(props) {
    super(props);
    
    const urlLocale = siteLocaleLanguages.filter(key => window.location.pathname.startsWith(`/${key}/`) || window.location.pathname === `/${key}`)[0];
    
    let newLanguage = urlLocale ? urlLocale : localStorage.getItem('locale') || 'en';

    this.state = {
      newLanguage: newLanguage,
    }
  }
  
  componentDidMount() {
    const {
      changeLanguage
    } = this.props;   
        
    let oldUrl = window.location.pathname + window.location.search + window.location.hash

    if (oldLanguage !== this.state.newLanguage ){
      changeLanguage(this.state.newLanguage );
    }
    else {
      let reg1 = new RegExp('^/(?:(?:e[ns]|f[ar]|hi|kok)|[amou]r)$')
      let reg2 = new RegExp('^/(?:(?:e[ns]|f[ar]|hi|kok)|[amou]r)/')
      if(!reg1.test(oldUrl) && !reg2.test(oldUrl)) {
        window.location.assign(`/${this.state.newLanguage}${oldUrl}`);
      }
    }
  }
  render() {      
    return (
      <BrowserRouter basename={this.state.newLanguage}>
        {this.props.children}
      </BrowserRouter>
    )
  }
}

ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <ConnectedI18n>
        <ConnectedRouter history={history}>
        <ExtendedBrowserRouter>
          <RTLProvider>
            <Switch>
              <Route exact path="/stories/embed/reader/:slug" component={EmbedBookReaderContainer} />
              <Route exact path="/stories/embed/:slug" component={EmbedBookCard} />
              <AppContainer>
                <Switch>
                  <RouteWithOfflineRedirect exact path="/" component={ProfileHomeContainer} />
                  <RouteWithOfflineRedirect exact path={`/${mapUserGatewayProfileType[userProfileType.PARENT]}`} render={props => <HomeContainer {...props} profileType={mapUserGatewayProfileType[userProfileType.PARENT]}/>}/> 
                  <RouteWithOfflineRedirect exact path={`/${mapUserGatewayProfileType[userProfileType.STUDENT]}`} render={props => <HomeContainer {...props} profileType={mapUserGatewayProfileType[userProfileType.STUDENT]}/>}/> 
                  <RouteWithOfflineRedirect exact path={`/${mapUserGatewayProfileType[userProfileType.TEACHER]}`} render={props => <HomeContainer {...props} profileType={mapUserGatewayProfileType[userProfileType.TEACHER]}/>}/> 
                  <RouteWithOfflineRedirect exact path="/users/:slug" render={props => <ProfileContainer {...props} profileType={profileTypes.USER} />} />
                  <RouteWithOfflineRedirect exact path={`/${mapProfileTypeToSlug[profileTypes.ORGANISATION]}/:slug`} render={props =>  <ProfileContainer {...props} profileType={profileTypes.ORGANISATION} />} />
                  <RouteWithOfflineRedirect exact path={`/${mapProfileTypeToSlug[profileTypes.PUBLISHER]}/:slug`} render={props => <ProfileContainer {...props} profileType={profileTypes.PUBLISHER} />} />
                  <RouteWithOfflineRedirect exact path={`/${mapProfileTypeToSlug[profileTypes.TRANSLATION_PARTNER]}/:slug`} render={props => <ProfileContainer {...props} profileType={profileTypes.TRANSLATION_PARTNER} />} />
                  <RouteWithOfflineRedirect exact strict path="/lists" component={ListsHomeContainer} />
                  <RouteWithOfflineRedirect exact strict path="/lists/" component={AllListsContainer} />
                  <RouteWithOfflineRedirect exact strict path="/lists/:slug" component={ReadingListContainer} />
                  <RouteWithOfflineRedirect exact path="/translate" component={TranslateContainer} />
                  <RouteWithOfflineRedirect exact path="/translate/all" component={AllTranslateListingContainer} />
                  <RouteWithOfflineRedirect exact path="/stories" component={AllBooksContainer} />
                  <RouteWithOfflineRedirect exact path="/audios" component={AllBooksContainer} />
                  <RouteWithOfflineRedirect exact path="/contact" component={Contacts} />
                  <Route exact path="/stories/short-story" render={() => <Redirect to="/stories?language=English&level=1&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&
                  publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <Route exact path="/stories/kids-story" render={() => <Redirect to="/stories?language=English&level=1&level=2&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <Route exact path="/stories/funny-story" render={() => <Redirect to="/stories?category=Funny&language=English&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <Route exact path="/stories/friends-and-family-story" render={() => <Redirect to="/stories?category=Family%20%26%20Friends&language=English&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <Route exact path="/stories/math-story" render={() => <Redirect to="/stories?category=Math&language=English&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <Route exact path="/stories/adventure-story" render={() => <Redirect to="/stories?category=Adventure%20%26%20Mystery&language=English&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <Route exact path="/stories/fiction-story" render={() => <Redirect to="/stories?category=Fiction&language=English&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <Route exact path="/stories/bedtime-story" render={() => <Redirect to="/stories?category=Read-Aloud%20Stories&language=English&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <Route exact path="/stories/animal-story" render={() => <Redirect to="/stories?category=Animal%20Stories&language=English&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <Route exact path="/stories/history-story" render={() => <Redirect to="/stories?category=History&language=English&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <Route exact path="/stories/science-story" render={() => <Redirect to="/stories?category=STEM&language=English&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <Route exact path="/stories/poems" render={() => <Redirect to="/stories?category=Poems&language=English&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <Route exact path="/stories/biography-story" render={() => <Redirect to="/stories?category=Biographies&language=English&publisher=African%20Storybook%20Initiative&publisher=Book%20Dash&publisher=Ms%20Moochie&publisher=Pratham%20Books&publisher=StoryWeaver&query=&sort=Relevance" />} />
                  <RouteWithOfflineRedirect exact path="/search" render={props => <AllBooksContainer {...props} isSearchVariant />} />
                  <Route exact path="/stories/:slug" component={BookContainer} />
                  <Route exact path="/offline" component={OfflineBooksContainer} />
                  <Route exact path="/offline/:slug" component={OfflineBooksContainer} />
                  <RouteWithOfflineRedirect exact path="/translator/un_translated_stories" component={TranslatePartnerContainer} />
                  <Route exact path="/reset-password/:token" component={ResetPasswordRoute} />
                  <Route exact path="/email-confirmation/:token" render={props => <EmailConfirmationContainer {...props}/>}/>
                  <Route exact path="/third-party-user-login/:token" render={props => <ThirdPartyUserAuthContainer {...props}/>}/>
                  <Route exact path="/videos" component={Channel} />
                  <Route exact path="/donate" component={DonatePage} />
                  <Route exact path="/jotform-dashboard" component={JotformContainer} />
                  <Route exact path="/about/impact/:slug" component={ImpactStaticPageContainer} />
                  <RouteWithOfflineRedirect exact path="/profile" component={UserProfileContainer} />
                  <RouteWithOfflineRedirect exact path="/editor/:parentId/mobile-translate/:templateId/book-title" component={MobileTranslatePublishContainer} />
                  <RouteWithOfflineRedirect exact path="/editor/:parentId/mobile-translate/:templateId" component={MobileTranslateContainer} />
                  <RouteWithOfflineRedirect exact path="/editor/:parentId/mobile-translate/:templateId/publish" component={MobileTranslatePublishContainer} />
                  <ProgramSpecificI18n exact path="/stem-literacy-programme" component={StemHome} />
                  <ProgramSpecificI18n exact path="/stem-literacy-programme/about/:slug" component={StemIntroContainer} />
                  <ProgramSpecificI18n exact path="/stem-literacy-programme/stem-topics" component={StemTopicContainer} />
                  <ProgramSpecificI18n exact path="/stem-literacy-programme/tags" component={StemTagContainer} />
                  <ProgramSpecificI18n exact path="/stem-literacy-programme/trainingresources" render={props => <StemMoocContainer {...props} program={"stem"} />} />
                  <ProgramSpecificI18n exact path="/stem-literacy-programme/trainingresources/:slug" render={props => <StemMoocModuleContainer {...props} program={"stem"} />} />
                  <ProgramSpecificI18n exact path="/stem-literacy-programme/about/stem-topics/:subject/:slug" component={StemGroupings} />
                  <ProgramSpecificI18n exact path="/stem-literacy-programme/maths" render={props => <StemTopicContainer {...props} subjectVariant={"Maths"} />} />
                  <ProgramSpecificI18n exact path="/stem-literacy-programme/science-evs" render={props => <StemTopicContainer {...props} subjectVariant={"EVS"} />} />
                  <ProgramSpecificWithoutRedirect exact path="/stem-literacy-programme/stories/:slug" render={props => <BookContainer {...props} fromStem/>} />
                  <Route exact path="/stem-literacy-programme/lesson-plan/31" render={() => <Redirect to={`/stem-literacy-programme/maths/lesson-plan/31?language=en`} />} />
                  <Route exact path="/stem-literacy-programme/lesson-plan/18" render={() => <Redirect to={`/stem-literacy-programme/science/lesson-plan/18?language=en`} />} />
                  <Route exact path="/stem-literacy-programme/lesson-plan/15" render={() => <Redirect to={`/stem-literacy-programme/maths/lesson-plan/15?language=en`} />} />
                  <Route exact path="/stem-literacy-programme/lesson-plan/30" render={() => <Redirect to={`/stem-literacy-programme/science/lesson-plan/30?language=en`} />} />
                  <Route exact path="/stem-literacy-programme/lesson-plan/35" render={() => <Redirect to={`/stem-literacy-programme/science/lesson-plan/35?language=en`} />} />
                  <Route exact path="/stem-literacy-programme/lesson-plan/65" render={() => <Redirect to={`/stem-literacy-programme/science/lesson-plan/65?language=en`} />} />
                  <ProgramSpecificWithoutRedirect exact path="/stem-literacy-programme/:subject/lesson-plan/:id" component={LessonPlanContainer} />
                  <ProgramSpecificI18n exact path="/reading-programme" component={ReadingProgramLandingContainer} />
                  <RouteWithOfflineRedirect exact path="/reading-programme/:slug" component={FluencyContainer} />
                  <ProgramSpecificI18n exact path="/reading-programme/:fluencyId/theme/:slug" component={ThemeContainer} />
                  <RouteWithOfflineRedirect exact path="/foundational-literacy" component={CsfLandingContainer} />
                  <RouteWithOfflineRedirect exact path="/foundational-literacy/program-overview" component={CsfProgramOverviewContainer} />
                  <RouteWithOfflineRedirect exact path="/foundational-literacy/levels" component={CsfLevelContainer} />
                  <ProgramSpecificI18n exact path="/foundational-literacy-programme/all-books" component={FlpAllBooksContainer} />
                  <RouteWithOfflineRedirect exact path="/foundational-literacy/resource/:slug" render={props => <CsfResourceContainer {...props} program={"csf"} />}/>
                  <RouteWithOfflineRedirect exact path="/foundational-create-classroom" component={FlpClassroomLandingContainer} />
                  <RouteWithOfflineRedirect exact path="/foundational-create-classroom/my-classrooms" component={FlpCreateClassroom} />
                  <RouteWithOfflineRedirect exact path="/foundational-create-classroom/my-classrooms/:classroom" component={FlpStudentClassroom} />
                  <RouteWithOfflineRedirect exact path="/early-learning-resources" component={EceLandingContainer} />
                  <RouteWithOfflineRedirect exact path="/early-learning-resources/theme" component={EceThemeContainer} />
                  <RouteWithOfflineRedirect exact path="/early-learning-resources/videos" component={EceVideosContainer} />
                  <RouteWithOfflineRedirect exact path="/early-learning-resources/conversation-posters" component={EceConversationContainer} />
                  <ProgramSpecificI18n exact path="/foundational-literacy-at-home" render={(props) => <Redirect to={`/foundational-literacy-programme${props.location.search}`} />} />
                  <ProgramSpecificI18n exact path="/foundational-literacy-programme" component={FlpReadAtHomeLandingContainer} />
                  <ProgramSpecificI18n exact path="/foundational-literacy-at-home/grades" render={(props) => <Redirect to={`/foundational-literacy-programme/grades${props.location.search}`} />}/>
                  <ProgramSpecificI18n exact path="/foundational-literacy-programme/grades" component={FlpReadAtHomeResourceContainer}/>
                  <ProgramSpecificI18n exact path="/foundational-literacy-at-home/trainingresources" render={(props) => <Redirect to={`/foundational-literacy-programme/trainingresources${props.location.search}`}/>} />
                  <ProgramSpecificI18n exact path="/foundational-literacy-programme/trainingresources" render={props => <StemMoocContainer {...props} program={"flp"} />} />
                  <ProgramSpecificI18n exact path="/foundational-literacy-at-home/trainingresources/:slug" render={(props) => <Redirect to={`/foundational-literacy-programme/trainingresources/${props.match.params.slug}${props.location.search}`} />} />
                  <ProgramSpecificI18n exact path="/foundational-literacy-programme/trainingresources/:slug" render={props => <StemMoocModuleContainer {...props} program={"flp"} />} />
                  <ProgramSpecificI18n exact path="/foundational-literacy-at-home/:slug" render={(props) => <Redirect to={`/foundational-literacy-programme/${props.match.params.slug}${props.location.search}`} />} />
                  <ProgramSpecificI18n exact path="/foundational-literacy-programme/:slug" component={FlpReadAtHomeAboutContainer} />
                  <ProgramSpecificI18n exact path="/foundational-literacy-at-home/resource/:slug" render={(props) => <Redirect to={`/foundational-literacy-programme/resource/${props.match.params.slug}${props.location.search}`} />}/>
                  <ProgramSpecificI18n exact path="/foundational-literacy-programme/resource/:slug" render={props => <CsfResourceContainer {...props} program={"flp"} />}/>
                  <RouteWithOfflineRedirect exact path="/me/lists" component={MyListsContainer} />
                  <RouteWithOfflineRedirect exact path="/illustrations" component={AllImagesContainer} />
                  <RouteWithOfflineRedirect exact path="/illustrations/:slug" component={IllustrationContainer} />
                  <RouteWithOfflineRedirect exact path="/lists" component={AllListsContainer} />
                  <RouteWithOfflineRedirect exact path="/about/impact-stories" component={SpAllImpactsPage} />
                  <RouteWithOfflineRedirect exact path="/about/explore" component={SpCampaignsPage} />
                  <RouteWithOfflineRedirect exact path="/about/COVID-19-response" component={SpCovid19Page} />
                  <Route exact path="/free-storybooks-for-kids" render={() => <Redirect to="/about/explore/free-storybooks-for-kids" />} />
                  <Route exact path="/free-online-books-for-kids" render={() => <Redirect to="/about/explore/free-online-books-for-kids" />} />
                  <Route exact path="/storybook-in-english-for-kids" render={() => <Redirect to="/about/explore/storybook-in-english-for-kids" />} />
                  <Route exact path="/kids-books-online" render={() => <Redirect to="/about/explore/kids-books-online" />} />
                  <Route exact path="/why-reading-to-children-is-important" render={() => <Redirect to="/about/explore/why-reading-to-children-is-important" />} />
                  <Route exact path="/animal-stories-for-kids" render={() => <Redirect to="/about/explore/animal-stories-for-kids" />} />
                  <Route exact path="/english-story-books" render={() => <Redirect to="/about/explore/english-story-books" />} />
                  <Route exact path="/bedtime-stories-for-kids" render={() => <Redirect to="/about/explore/bedtime-stories-for-kids" />} />
                  <Route exact path="/hindi-stories-for-kids" render={() => <Redirect to="/about/explore/hindi-stories-for-kids" />} />
                  <Route exact path="/kids-audio-stories" render={() => <Redirect to="/about/explore/kids-audio-stories" />} />
                  <Route exact path="/short-stories-with-pictures-for-kids" render={() => <Redirect to="/about/explore/short-stories-with-pictures-for-kids" />} />
                  <Route exact path="/best-story-books" render={() => <Redirect to="/about/explore/best-story-books" />} />
                  <Route exact path="/easy-stories-for-kids" render={() => <Redirect to="/about/explore/easy-stories-for-kids" />} />
                  <Route exact path="/storyweaver-childrens-comic-books" render={() => <Redirect to="/about/explore/storyweaver-childrens-comic-books" />} />
                  <Route exact path="/storyweaver-history-stories-for-kids" render={() => <Redirect to="/about/explore/storyweaver-history-stories-for-kids" />} />
                  <Route exact path="/storyweaver-best-kids-online-books-for-free" render={() => <Redirect to="/about/explore/storyweaver-best-kids-online-books-for-free" />} />
                  <Route exact path="/storyweaver-must-read-space-stories" render={() => <Redirect to="/about/explore/storyweaver-must-read-space-stories" />} />
                  <RouteWithOfflineRedirect exact path="/about/explore/free-storybooks-for-kids" component={SpExploreCampaignPage} />
                  <RouteWithOfflineRedirect exact path="/about/explore/free-online-books-for-kids" component={SpFreeOnlineBooksExplorePage} />
                  <RouteWithOfflineRedirect exact path="/about/explore/storybook-in-english-for-kids" component={SpStoryBookEnglishExplorePage} />
                  <RouteWithOfflineRedirect exact path="/about/explore/kids-books-online" component={SpExploreSBforKids} />
                  <RouteWithOfflineRedirect exact path="/about/explore/why-reading-to-children-is-important" component={SpReadingChildrenImpExplorePage} />
                  <RouteWithOfflineRedirect exact path="/about/explore/animal-stories-for-kids" component={SpExploreSeo1} />
                  <RouteWithOfflineRedirect exact path="/about/explore/english-story-books" component={SpExploreSeo2} />
                  <RouteWithOfflineRedirect exact path="/about/explore/bedtime-stories-for-kids" component={SpExploreSeo3} />
                  <RouteWithOfflineRedirect exact path="/about/explore/hindi-stories-for-kids" component={SpExploreSeo4} />
                  <RouteWithOfflineRedirect exact path="/about/explore/kids-audio-stories" component={SpExploreSeo5} />
                  <RouteWithOfflineRedirect exact path="/about/explore/short-stories-with-pictures-for-kids" component={SpExploreSeo6} />
                  <RouteWithOfflineRedirect exact path="/about/explore/best-story-books" component={SpExploreSeo7} />
                  <RouteWithOfflineRedirect exact path="/about/explore/easy-stories-for-kids" component={SpExploreSeo8} />        
                  <RouteWithOfflineRedirect exact path="/about/explore/storyweaver-childrens-comic-books" component={SpExploreSeo9} />        
                  <RouteWithOfflineRedirect exact path="/about/explore/storyweaver-history-stories-for-kids" component={SpExploreSeo10} />        
                  <RouteWithOfflineRedirect exact path="/about/explore/storyweaver-best-kids-online-books-for-free" component={SpExploreSeo11} />        
                  <RouteWithOfflineRedirect exact path="/about/explore/storyweaver-must-read-space-stories" component={SpExploreSeo12} />        
                  <RouteWithOfflineRedirect exact path="/about/:slug" component={SpContainer} />
                  <RouteWithOfflineRedirect exact path="/latest/:slug" component={SpMediaContainer} />
                  <RouteWithOfflineRedirect exact path="/latest/in-the-news/:slug" component={SpStandardNewsPage} />
                  <RouteWithOfflineRedirect exact path="/help/faqs" component={SpFaqContainer} />
                  <RouteWithOfflineRedirect exact path="/help/faqs/:slug" component={SpFaqContainer} />
                  <RouteWithOfflineRedirect exact path="/impact/awards" component={SpAwardsContainer}/>
                  <RouteWithOfflineRedirect exact path="/careers" render={props => <SpCareerContainer {...props} pageVariant={"careers"} />} />
                  <RouteWithOfflineRedirect exact path="/careers/:slug" component={SpCareerDetailPage}/>
                  <RouteWithOfflineRedirect exact path="/volunteer" render={props => <SpCareerContainer {...props} pageVariant={"volunteer"} />} />
                  <RouteWithOfflineRedirect exact path="/about/campaigns/discover-stem-through-stories" component={SpStemCampaign} />
                  <RouteWithOfflineRedirect exact path="/about/campaigns/goshticha-shaniwar-reading-programme" component={SpIndvCampaignPage} />
                  <RouteWithOfflineRedirect exact path="/about/campaigns/cbse-reading-mission" component={SpCbseCampaignPage} />
                  <RouteWithOfflineRedirect exact path="/about/campaigns/foundational-literacy" component={SpFlpCampaignPage} />
                  <RouteWithOfflineRedirect exact path="/about/campaigns/cbse-budding-authors" component={SpCbseBuddingAuthors} />
                  <RouteWithOfflineRedirect exact path="/about/campaigns/cbse-reading-mission/faqs" component={SpCbseCampaignPageFaqs} />
                  <ProgramSpecificI18n exact path="/about/campaigns/worldbookday" render={() => window.location.href= ' https://youtu.be/d9aZUopPZto '} />
                  <ProgramSpecificI18n exact path="/about/campaigns/getchildrenreading" component={SpPledgeToRead} />
                  <ProgramSpecificI18n exact path="/about/campaigns/getchildrenreading/pcertificate" component={SpPledgeToReadPartner} />
                  <ProgramSpecificI18n exact path="/certificates" component={EventTypeCertificate} />
                  {isOdosWeek && <ProgramSpecificI18n exact path="/about/campaigns/getchildrenreading/odoscertificate" component={SpOdosCertificate} />}
                  <ProgramSpecificI18n exact path="/about/campaigns/getchildrenreading/pledge" render={() => <Redirect to="/about/campaigns/getchildrenreading" />}/>
                  <ProgramSpecificI18n exact path="/readalongs" render={props => <ResourcesLandingPage {...props} category={"readalongs"} />} />
                  <ProgramSpecificI18n exact path="/wordless" render={props => <ResourcesLandingPage {...props} category={"wordless"} />} />
                  <ProgramSpecificI18n exact path="/bilinguals" render={props => <ResourcesLandingPage {...props} category={"bilinguals"} />} />
                  <RouteWithOfflineRedirect exact path="/about/campaigns/getchildrenreading/worldbookday23" component={PTRVideoPage} />
                  <RouteWithOfflineRedirect exact path="/about/campaigns/getchildrenreading/partner" component={GcrSubCampaign} />
                  <RouteWithOfflineRedirect exact path="/about/campaigns/:slug" component={SpStandardCampaign} />
                  <RouteWithOfflineRedirect path={new RegExp('^/(?:(?:e[ns]|f[ar]|hi|kok)|[amou]r)/v0')} />
                  <RouteWithOfflineRedirect path={new RegExp('^/v0')} />
                  <RouteWithOfflineRedirect path="/errors/error_500" component={ErrorPage}  />
                  {/* Created a wild card path with an asterisk(‘*’) and added it as the very last path to capture all the wrong routes */}
                  <RouteWithOfflineRedirect path="*" render={props => <ErrorPage {...props}  showErrorText />}/>
                </Switch>
              </AppContainer>
            </Switch>
          </RTLProvider>
          </ExtendedBrowserRouter>
        </ConnectedRouter>
      </ConnectedI18n>
    </Provider>
  </CookiesProvider>,
  document.getElementById('root')
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
    .then(registration => {
      const serviceWorker = registration.active;

      // to handle existing RP books for SW-4698
      if (serviceWorker) {
        serviceWorker.postMessage({
          action: 'offlineBooks',
          offlineBooks: JSON.parse(localStorage.getItem('reduxPersist:offlineBooks'))
        });
      }
    })
}



// WEBPACK FOOTER //
// ./src/index.jsx